import React from "react";
import { IonItem } from "@ionic/react";
import { IEvidence, WPBAForm } from "@interfaces/Interfaces";
import { Button_Disclosure_Right_Grey } from "@assets/images";

type Props = {
  form: WPBAForm;
  buttonPressed: () => void;
  programEvidence: IEvidence[];
};

const WPBAFormButton: React.FC<Props> = (props) => {
  const formEvidenceDefinition = props.form["Evidence Definitions"]?.find(
    (item) => item.EvidenceSelectionType === "wpba-supervision-form"
  );

  const count = props.programEvidence.filter(
    (evidence) => evidence.evidenceJSON.programInfo.programEvidenceDefinitionID === formEvidenceDefinition?.ID
  ).length;

  return (
    <IonItem
      button
      className="part program-skill-button !flex !w-full flex-col !pl-0 !shadow-unset"
      detail={false}
      key={props.form.ID}
      onClick={props.buttonPressed}
    >
      <div className="w-full pl-0">
        <div className="flex flex-row items-center justify-between py-[8px] shadow-program-skill shadow-grey-30">
          <div className="flex flex-col">
            <div className="text-acc-15px leading-[1.33] tracking-[-0.3px] text-grey-90">{props.form.Name}</div>
            <div className="text-acc-11px font-medium leading-[1.27] text-grey-60">{`${count} evidence`}</div>
          </div>
          <div className="ml-4 flex flex-shrink-0 flex-row items-center">
            <img
              className="img-no-select size-6"
              src={Button_Disclosure_Right_Grey}
            />
          </div>
        </div>
      </div>
    </IonItem>
  );
};

export default WPBAFormButton;
